var _circle, _circle2, _circle3, _rect, _rect2, _rect3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInactiveListIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 470 470",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 93.5,
    cy: 124.5,
    r: 38.5,
    fill: "#B2BFCA"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 93.5,
    cy: 344.5,
    r: 38.5,
    fill: "#B2BFCA"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 93.5,
    cy: 234.5,
    r: 38.5,
    fill: "#B2BFCA"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 157,
    y: 103,
    width: 259,
    height: 43,
    fill: "#B2BFCA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 157,
    y: 323,
    width: 259,
    height: 43,
    fill: "#B2BFCA"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 157,
    y: 213,
    width: 259,
    height: 43,
    fill: "#B2BFCA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactiveListIcon);
export default __webpack_public_path__ + "static/media/inactive-list-icon.b8003641.svg";
export { ForwardRef as ReactComponent };